import * as types from '@/store/types'

const state = {
    items: JSON.parse(localStorage.getItem('cuttingItems')) || [],
    optimizations: JSON.parse(localStorage.getItem('optimizationItems')) || undefined
}

const getters = {
    cuttingItems: state => state.items,
    optimizationItems: state => state.optimizations
}

const mutations = {
    [types.ADD_ITEM_TO_STORE](state, item) {
        state.items.push(item)
        localStorage.setItem('cuttingItems', JSON.stringify(state.items))
    },
    [types.ADD_OPTIMIZATION_ITEMS_TO_STORE](state, item) {
        state.optimizations = item
        localStorage.setItem('optimizationItems', JSON.stringify(state.optimizations))
    },
    [types.REMOVE_ALL_ITEMS_FROM_STORE](state) {
        state.items = []
        state.optimizations = undefined
        localStorage.removeItem('cuttingItems')
        localStorage.removeItem('optimizationItems')
    },
    [types.REMOVE_ITEM_FROM_STORE](state, id) {
        localStorage.removeItem('cuttingItems')
        localStorage.removeItem('optimizationItems')
        for (var i = state.items.length - 1; i >= 0; i--) {
            if (state.items[i].id === id) {
                state.items.splice(i, 1);
            }
        }
        localStorage.setItem('cuttingItems', JSON.stringify(state.items))
    },
    removeOptimizationItems(state) {
        state.optimizations = undefined
        localStorage.removeItem('optimizationItems')
    }
}

export default {
    state,
    getters,
    mutations
}